import { gql } from "@apollo/client";

const FIELDS = `
  id name gender status title subtitle categoryIds excludeServiceIds startAt endAt version publishedAt updatedAt eligibleCount
  tiers { minItems percent }
  rules { maxItems minTotal maxDiscount maxPerCategory oneVariantPerArea allowCoupons }
`;

export const GET_PACKAGE_BUILDERS = gql`
  query GetPackageBuilders { getPackageBuilders { status message builders { ${FIELDS} } } }
`;

export const PREVIEW_PACKAGE_BUILDER = gql`
  query PreviewPackageBuilder($data: PackageBuilderInput!) {
    previewPackageBuilder(data: $data) {
      status message
      builder { minItems groups { categoryId name services { id name price campaignPrice image } } }
    }
  }
`;

export const PREVIEW_PACKAGE_QUOTE = gql`
  query PreviewPackageQuote($data: PackageBuilderInput!, $serviceIds: [ID!]!) {
    previewPackageQuote(data: $data, serviceIds: $serviceIds) {
      status message
      quote { ok errors count subtotal percent discount total nextTier { minItems percent needed } }
    }
  }
`;

export const SAVE_PACKAGE_BUILDER = gql`
  mutation SavePackageBuilder($data: PackageBuilderInput!) { savePackageBuilder(data: $data) { status message id } }
`;
export const PUBLISH_PACKAGE_BUILDER = gql`
  mutation PublishPackageBuilder($id: ID!) { publishPackageBuilder(id: $id) { status message } }
`;
export const ARCHIVE_PACKAGE_BUILDER = gql`
  mutation ArchivePackageBuilder($id: ID!) { archivePackageBuilder(id: $id) { status message } }
`;
export const DELETE_PACKAGE_BUILDER = gql`
  mutation DeletePackageBuilder($id: ID!) { deletePackageBuilder(id: $id) { status message } }
`;
